module.exports = __webpack_public_path__ + "media/images/category/feature/coj_f/coj_f-2-3754beab9c7dff88984d5e4bfabeafc4.jpg";